import React, { useEffect, useState } from "react";
import { api, extractError } from "@/lib/api";
import { Link } from "react-router-dom";
import { Folder, Plus, X } from "lucide-react";

export default function Collaborators() {
    const [list, setList] = useState([]);
    const [show, setShow] = useState(false);
    const [form, setForm] = useState({ name: "", email: "", phone: "", notes: "", commission: "" });
    const [err, setErr] = useState("");

    const load = async () => {
        const { data } = await api.get("/collaborators");
        setList(data);
    };
    useEffect(() => { load(); }, []);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        try {
            await api.post("/collaborators", form);
            setForm({ name: "", email: "", phone: "", notes: "", commission: "" });
            setShow(false); load();
        } catch (e) { setErr(extractError(e)); }
    };

    return (
        <div className="p-6" data-testid="collaborators-page">
            <div className="flex items-baseline justify-between mb-4">
                <div>
                    <h1 className="font-display text-2xl font-semibold tracking-tight text-neutral-900">Collaboratori</h1>
                    <div className="text-sm text-neutral-500">Procacciatori esterni · {list.length} totali</div>
                </div>
                <button onClick={() => setShow(true)} data-testid="new-collaborator-btn"
                    className="inline-flex items-center gap-1.5 bg-neutral-900 text-white text-sm font-medium px-3 py-1.5 rounded-md hover:bg-neutral-800">
                    <Plus size={14} /> Nuovo
                </button>
            </div>

            {list.length === 0 ? (
                <div className="bg-white border border-neutral-200 rounded-md p-10 text-center" data-testid="empty-state">
                    <div className="font-display text-neutral-800 font-medium">Nessun collaboratore</div>
                    <div className="text-sm text-neutral-500 mt-1">Aggiungi il primo procacciatore.</div>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    {list.map((c) => (
                        <Link key={c.id} to={`/collaboratori/${c.id}`} data-testid={`collab-card-${c.id}`}
                            className="bg-white border border-neutral-200 rounded-md p-4 hover:border-neutral-300 hover:shadow-sm transition flex items-start gap-3">
                            <div className="p-2 rounded bg-amber-50 text-amber-700 border border-amber-100"><Folder size={20} /></div>
                            <div className="flex-1 min-w-0">
                                <div className="font-medium text-neutral-900 truncate">{c.name}</div>
                                <div className="text-xs text-neutral-500 truncate">{c.email || "—"}</div>
                                <div className="text-xs text-neutral-700 mt-1"><b>{c.client_count}</b> clienti procurati</div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}

            {show && (
                <div className="fixed inset-0 bg-neutral-900/50 z-50 flex items-center justify-center p-4" onClick={() => setShow(false)}>
                    <form onClick={(e) => e.stopPropagation()} onSubmit={submit}
                        className="bg-white rounded-md shadow-lg w-full max-w-md" data-testid="new-collab-modal">
                        <div className="flex items-center justify-between px-5 py-3 border-b border-neutral-200">
                            <div className="font-display font-semibold">Nuovo collaboratore</div>
                            <button type="button" onClick={() => setShow(false)}><X size={16} /></button>
                        </div>
                        <div className="p-5 space-y-3">
                            <F label="Nome*"><input required data-testid="collab-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-2 py-1.5 border border-neutral-300 rounded text-sm" /></F>
                            <F label="Email"><input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-2 py-1.5 border border-neutral-300 rounded text-sm" /></F>
                            <F label="Telefono"><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full px-2 py-1.5 border border-neutral-300 rounded text-sm" /></F>
                            <F label="Accordo / provvigione"><input value={form.commission} onChange={(e) => setForm({ ...form, commission: e.target.value })} className="w-full px-2 py-1.5 border border-neutral-300 rounded text-sm" /></F>
                            <F label="Note"><textarea rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full px-2 py-1.5 border border-neutral-300 rounded text-sm" /></F>
                        </div>
                        {err && <div className="mx-5 mb-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">{err}</div>}
                        <div className="px-5 py-3 border-t border-neutral-100 flex justify-end gap-2 bg-neutral-50">
                            <button type="button" onClick={() => setShow(false)} className="px-3 py-1.5 text-sm rounded border border-neutral-300 bg-white">Annulla</button>
                            <button type="submit" data-testid="save-collab-btn" className="px-3 py-1.5 text-sm rounded bg-neutral-900 text-white hover:bg-neutral-800">Salva</button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
}
function F({ label, children }) { return <label className="block"><span className="text-xs font-medium text-neutral-600">{label}</span><div className="mt-1">{children}</div></label>; }
